export enum DynamicLoaderStatuses {
  AlreadyLoaded = 'Already Loaded',
  Failed = 'Loading Failed',
  Loaded = 'Loaded',
  NotLoaded = 'Not Loaded',
}
